let timer : number | null = null;

export const FilterTimerSearch = (searchingSetter : Function, callback : Function) => {
    searchingSetter(true);
    if(timer) {
        clearTimeout(timer);
        timer = null;
    }

    timer = window.setTimeout(() => {
        callback();
        searchingSetter(false);
    },1500);

}